import React, {useEffect, useState} from 'react';
import axios from 'axios';
import {Col, Container, Row} from 'reactstrap';
import {DateTime} from 'luxon';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faChild} from '@fortawesome/pro-light-svg-icons/faChild';
import {faExclamationTriangle} from '@fortawesome/pro-light-svg-icons/faExclamationTriangle';
import {faGlobeAmericas} from '@fortawesome/pro-light-svg-icons/faGlobeAmericas';
import {faSeedling} from '@fortawesome/pro-light-svg-icons/faSeedling';
import {faTimes} from '@fortawesome/pro-light-svg-icons/faTimes';
import {subscribeToCampaign} from 'react-controlled-ab/datalayers/vwo';
import classNames from 'classnames';
import ReactMarkdown from 'react-markdown';

import {usePhaseState, usePhaseDispatch} from 'funnel-schedule/phase-context';
import {useUserState, useUserDispatch} from 'contexts/user';

import Divider from 'components/Divider';
import TntgSpeakerList from 'components/TntgSpeaker';
import BonusList from 'components/BonusList';
import IconList, {IconListItem, ListIcon} from 'components/Elements/IconList';
import Blockquote from 'components/Blockquote';
import ImgBullet, {ImgBulletCard} from 'components/ImgBullet';
import InterviewList from 'components/InterviewList';
import BackgroundImageTextSection from 'components/BackgroundImageTextSection';
import {ThcBonusList} from 'components/Thc/CheckoutSelection';
import Guarantee from 'components/Guarantee';
import {TestimonialBubble} from 'components/Testimonial';
import {faEarth} from '@fortawesome/pro-regular-svg-icons';

//@ts-ignore
import {collection as thcCollection} from 'data/thc.json';
//@ts-ignore
import {speakers as masterclass} from 'components/TntgSpeaker/data.json';
//@ts-ignore
import {bonus as bonuses} from 'components/BonusList/data.json';

//Due to a limitation of dotenv we must use three seperate statements
const {SF_API_URL} = process.env;
const {SITE_ID} = process.env;

export default function SalesCopy({salesCta, ...props}) {
  const phaseDispatch = usePhaseDispatch();
  const userDispatch = useUserDispatch();
  const {phases = {}} = usePhaseState();
  const {default: context = {}} = phases;
  const {phase} = context;
  const {events = [], registrationId} = useUserState();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  useEffect(() => {
    registrationId &&
      axios
        .get(`${SF_API_URL}/site/${SITE_ID}/state/`, {
          params: {
            registrationId
          }
        })
        .then(({data}) => {
          if (!data.webinar) {
            data.webinar = {
              phase: 'after',
              time: Math.floor(DateTime.utc().minus({days: 5}).toSeconds())
            };
          }
          const {firedEvents = []} = data.webinar;

          phaseDispatch({
            type: 'SET_PHASE',
            payload: data
          });
          firedEvents.map((e) => userDispatch({type: 'ADD_EVENT', payload: e}));
        });
  }, []);

  return (
    <>
      <div className="impact-kit wrapper background-gradient-gray-white triangle-angles-top triangle-angles-top-gray triangle-angles-offset-bottom">
        <Container>
          <Row className="d-flex justify-content-center">
            <Col xs="12" lg="10">
              <h2 className="text-center text-condensed text-800 mb-2">
                <em>The Need To GROW</em> <br className="d-none d-sm-block d-lg-none" />
                movie is Step #1.
              </h2>
              <h3 className="text-center mb-2">But we must NOT stop there.</h3>
              <h4 className="text-center">
                Our future is in SERIOUS <br className="d-none d-sm-block d-xl-none" />
                trouble — <em>will we even have one?</em>
              </h4>
              <p>Most food in mainstream grocery stores is grown with...</p>
              <IconList iconColor="red">
                <IconListItem icon={faTimes}>dangerous pesticides</IconListItem>
                <IconListItem icon={faTimes}>synthetic fertilizers</IconListItem>
                <IconListItem icon={faTimes}>nutritionally depleted soil</IconListItem>
              </IconList>
              <p>
                And is produced in ways that deplete and pollute the soil and water, creating potentially massive food
                shortages for generations to come.
              </p>
              <h4 className="mt-5">
                Some experts predict that at current rates of erosion,{' '}
                <em>we will run out of farmable soil in just 60 years,</em>{' '}
                <br className="d-none d-sm-block d-md-none" />
                leading to:
              </h4>
              <IconList iconColor="orange" className="mb-5">
                <IconListItem icon={faExclamationTriangle}>
                  Worsening health problems: more cancer, disease, and immune issues
                </IconListItem>
                <IconListItem icon={faExclamationTriangle}>
                  Skyrocketing food costs as resources like clean water and soil grow scarce
                </IconListItem>
                <IconListItem icon={faExclamationTriangle}>
                  Environmental devastation — butterfly, bee, and plant extinction is just the start
                </IconListItem>
                <IconListItem icon={faExclamationTriangle}>
                  And eventually, in as little as two generations, for many people... NO FOOD
                </IconListItem>
              </IconList>
              <h3 className="text-center">Unless we act NOW.</h3>
              <p className="text-center">
                Will your children and grandchildren <br className="d-none d-sm-block d-xl-none" />
                inherit a planet they can’t live on?
              </p>
              <p className="text-center">
                Or will they be able to say that YOU <br className="d-none d-sm-block d-md-none" />
                helped turn things around?
              </p>
              <h2 className="text-center text-condensed text-800 mt-4 mb-0">We CAN make things right.</h2>
              <h2 className="text-center text-condensed text-800 mb-0">It is NOT too late.</h2>
            </Col>
          </Row>
        </Container>
      </div>

      <div className="quote-section background-black text-white triangle-both-offset-top triangle-angles-offset-bottom triangle-angles-top triangle-angles-top-black wrapper">
        <Container>
          <Row className="d-flex justify-content-center">
            <Col xs="12" md="10" lg="11" xl="9">
              <Blockquote id="margaret-mead" />
            </Col>
          </Row>
        </Container>
      </div>

      <div className="background-gradient-white-gray triangle-both-offset-top triangle-angles-offset-bottom triangle-angles-top triangle-angles-top-white wrapper">
        <Container>
          <Row>
            <Col>
              {props.screeningTestimonials ? <TestimonialBubble id="renee" className="mb-5" /> : null}
              {props.salesTestimonials ? <TestimonialBubble id="dil" className="mb-5" /> : null}
              <TestimonialBubble id="evelyn" />
            </Col>
          </Row>
        </Container>
      </div>

      <div className="impact-info background-gradient-white-yellow triangle-angles-top triangle-angles-top-white triangle-angles-offset-bottom wrapper">
        <Container>
          <Row className="d-flex justify-content-center text-center mb-5">
            <Col xs="12">
              <h3 className="text-condensed text-800 mb-2">
                Join the most important fight <br className="d-none d-sm-block d-lg-none" />
                in our planet’s history.
              </h3>
              <h4 className="text-condensed text-800">And have FUN doing it!</h4>
              <h2 className="text-condensed text-800">
                <em>The Need To GROW</em> <span className="text-green text-800">Impact Kit</span>
              </h2>
              <p>
                Discover the #1 way to prevent disease, savor delicious <br className="d-none d-md-block d-lg-none" />
                home-grown food, <br className="d-none d-lg-block" />
                and contribute to a livable future for <br className="d-none d-sm-block d-lg-none" />
                Earth and its inhabitants.
              </p>
              <Row className="d-flex justify-content-center my-4">
                <Col xs="12" lg="8">
                  <img src="https://cdn.foodrevolution.org/tntg/tntg-productimage-digitalall.png" />
                </Col>
              </Row>
              <h4>
                The Ultimate Collection of Easy How-to Guides and <br className="d-none d-xl-block" />
                Video Trainings to Save <br className="d-none d-md-block d-lg-none" />
                Our Soil (and Your Health!).
              </h4>
              <h5>
                Designed for beginners and <br className="d-none d-sm-block d-lg-none" />
                advanced solutionists alike!
              </h5>
            </Col>
          </Row>
          <Row id="impact-cta">
            <Col>{salesCta}</Col>
          </Row>
        </Container>
      </div>

      <div className="background-gradient-white-gray triangle-angles-top triangle-angles-top-white triangle-angles-offset-bottom wrapper">
        <Container>
          <Row className="d-flex justify-content-center align-items-stretch text-center text-600">
            <Col xs="12" md="9" lg="4" className="d-flex flex-column px-lg-4 mb-5 mb-lg-0">
              <Row className="d-flex justify-content-center mb-3">
                <Col xs="12" lg="6">
                  <FontAwesomeIcon className="text-green text-icon" icon={faSeedling} />
                </Col>
              </Row>
              <p className="text-h5 my-auto">
                Learn the easiest ways to grow <br className="d-none d-sm-block d-md-none" />
                fresh, nutrient-dense, healing foods <br className="d-none d-sm-block d-md-none" />
                for you and your family.
              </p>
            </Col>
            <Col xs="12" md="9" lg="4" className="d-flex flex-column px-lg-4 mb-5 mb-lg-0">
              <Row className="d-flex justify-content-center mb-3">
                <Col xs="12" lg="6">
                  <FontAwesomeIcon className="text-green text-icon" icon={faGlobeAmericas} />
                </Col>
              </Row>
              <p className="text-h5 my-auto">
                Pitch in with simple strategies to reduce waste and help restore Earth’s most precious natural resource.
              </p>
            </Col>
            <Col xs="12" md="9" lg="4" className="d-flex flex-column px-lg-4">
              <Row className="d-flex justify-content-center mb-3">
                <Col xs="12" lg="6">
                  <FontAwesomeIcon className="text-green text-icon" icon={faChild} />
                </Col>
              </Row>
              <p className="text-h5 my-auto">
                Discover secrets to remove <br className="d-none d-sm-block d-md-none" />
                unwanted toxic chemical exposure <br className="d-none d-sm-block d-md-none" />
                to your children and community.
              </p>
            </Col>
          </Row>
        </Container>
      </div>
      <div
        className={classNames(
          `wrapper triangle-angles-top triangle-angles-top-white triangle-bottom triangle-bottom-white`
        )}
      >
        <Container>
          <Row className="justify-content-center">
            <Col lg="10">
              <h3 className="text-condensed text-800 text-center">Here’s What You’ll Get:</h3>
              <ImgBulletCard
                img="https://cdn.foodrevolution.org/tntg/images/tntg-screening_sales-here_s-what-you_ll-get-section-15video.png"
                imgColClass="p-2"
                imgColLg="4"
                textColLg="8"
              >
                <h4 className="text-condensed text-800 mb-0">15 Video Masterclasses</h4>
                <p className="mb-0">
                  to guide you on the #1 most <br className="d-none d-md-block d-lg-none" />
                  impactful <br className="d-none d-xl-block" />
                  steps to save the <br className="d-none d-md-block d-lg-none" />
                  planet and your health
                </p>
              </ImgBulletCard>
              <ImgBulletCard
                img="https://cdn.foodrevolution.org/tntg/images/tntg-screening_sales-here_s-what-you_ll-get-section-writtentranscripts.png"
                imgColClass="p-2"
                imgColLg="4"
                textColLg="8"
              >
                <h4 className="text-condensed text-800 mb-0">
                  Written Transcripts <br className="d-none d-xl-block" />
                  and Downloadable MP3s
                </h4>
                <p className="mb-0">to listen on the go</p>
              </ImgBulletCard>
              <ImgBulletCard
                img="https://cdn.foodrevolution.org/tntg/images/tntg-screening_sales-here_s-what-you_ll-get-section-neverbeforereleased.png"
                imgColClass="p-2"
                imgColLg="4"
                textColLg="8"
              >
                <h4 className="text-condensed text-800 mb-0">
                  Never-before-released <br className="d-none d-sm-block d-xl-none" />
                  Deleted Scenes
                </h4>
                <p className="mb-0">
                  from <em>The Need To GROW</em>
                </p>
              </ImgBulletCard>
              <ImgBulletCard
                img="https://cdn.foodrevolution.org/tntg/images/tntg-screening_sales-here_s-what-you_ll-get-section-over5hours.png"
                imgColClass="p-2"
                imgColLg="4"
                textColLg="8"
              >
                <h4 className="text-condensed text-800 mb-0">
                  Over Five Hours of <br className="d-none d-lg-block" />
                  Extended Expert Interviews
                </h4>
              </ImgBulletCard>
              <ImgBulletCard
                img="https://cdn.foodrevolution.org/tntg/images/tntg-screening_sales-here_s-what-you_ll-get-section-digitalcopy.png"
                imgColClass="p-2"
                imgColLg="4"
                textColLg="8"
              >
                <h4 className="text-condensed text-800 mb-0">The Digital Film for Life</h4>
              </ImgBulletCard>
              <ImgBulletCard
                img="https://cdn.foodrevolution.org/tntg/images/tntg-screening_sales-here_s-what-you_ll-get-section-gardening.png"
                imgColClass="p-2"
                imgColLg="4"
                textColLg="8"
              >
                <h4 className="text-condensed text-800 mb-0">Digital Gardening Courses</h4>
                <p className="mb-0">over $500 worth</p>
              </ImgBulletCard>
            </Col>
          </Row>
        </Container>
      </div>

      <BackgroundImageTextSection
        className="text-center text-white triangle-offset-top triangle-angles-offset-bottom"
        overlayColor="black"
        colClass="col-12"
        imgPosition="right-full-gradient"
        imgSrc={require('static/backgrounds/grid-angle.jpg')}
      >
        <Row>
          <Col>
            <h2>
              Never Before Seen Deleted <br className="d-none d-lg-block" />
              Scenes From The Film
            </h2>
            <p className="text-h6">
              You’ll get the complete deleted scenes <br className="d-none d-sm-block d-lg-none" />
              from <em>The Need To GROW.</em>
            </p>
            <p className="text-h6">
              Learn more on the backstory of the Green <br className="d-none d-md-block d-lg-none" />
              Power House, <br className="d-none d-xl-block" />
              and the surprise ending we can’t <br className="d-none d-md-block d-lg-none" />
              share here. (It’s very hopeful!)
            </p>
            <p className="text-h6">
              We couldn’t fit everything into a 90-minute <br className="d-none d-md-block d-lg-none" />
              documentary, and with the <br className="d-none d-xl-block" />
              Impact Kit, you won’t <br className="d-none d-md-block d-lg-none" />
              miss a minute of this life-changing film.
            </p>
          </Col>
        </Row>
      </BackgroundImageTextSection>

      <div className="background-gradient-white-yellow triangle-angles-top triangle-angles-top-white triangle-angles-offset-bottom wrapper">
        <Container>
          <Row>
            <Col>
              <h3 className="text-center text-condensed text-800 mb-5">
                With the Impact Kit, the solution <br className="d-none d-sm-block d-md-none" />
                is good for you <br className="d-none d-lg-block" />
                and good for <br className="d-none d-sm-block d-md-none" />
                the entire planet!
              </h3>
            </Col>
          </Row>
          <ImgBullet img={require('static/bullets/revitalize.jpg')} title="Revitalize">
            your body so you can fight disease and promote vibrant health with potent{' '}
            <br className="d-none d-sm-block d-md-none" />
            nutrient-dense foods.
          </ImgBullet>
          <ImgBullet img={require('static/bullets/restore.jpg')} title="Restore">
            your microbiome (the bacterial <br className="d-none d-sm-block d-md-none" />
            diversity your life depends on).
          </ImgBullet>
          <ImgBullet img={require('static/bullets/protect.jpg')} title="Protect">
            yourself and your loved ones from <br className="d-none d-sm-block d-md-none" />
            GMOs and pesticides.
          </ImgBullet>
          <ImgBullet img={require('static/bullets/grow.jpg')} title="Grow">
            food — even if you don’t have <br className="d-none d-sm-block d-md-none" />a green thumb — or even a green
            pinky!
          </ImgBullet>
          <ImgBullet img={require('static/bullets/compost.jpg')} title="Compost">
            with confidence — so your waste <br className="d-none d-md-block d-lg-none" />
            can help restore the earth, <br className="d-none d-md-block d-lg-none" />
            every day of your life.
          </ImgBullet>
          <ImgBullet img={require('static/bullets/plant.jpg')} title="Plant">
            indoors — even if you have space <br className="d-none d-sm-block d-md-none" />
            outside, you’ll see why it’s wonderful to <br className="d-none d-sm-block d-md-none" />
            bring plants into your home.
          </ImgBullet>
          <ImgBullet img={require('static/bullets/gain.jpg')} title="Gain">
            insight into biochar, topsoil, regenerative agriculture, and the future of life on earth — knowledge that
            every human needs right now!
          </ImgBullet>
        </Container>
      </div>

      <div className="impact-speakers background-gradient-white-yellow triangle-angles-top triangle-angles-top-white triangle-angles-offset-bottom wrapper">
        <Container>
          <Row className="mb-5">
            <Col>
              <h4 className="text-condensed text-800 text-center mb-2">
                <em>You can’t see these in a movie theater.</em>
              </h4>
              <h4 className="text-condensed text-800 text-center mb-2">
                <em>
                  You won’t find them on cable <br className="d-none d-sm-block d-lg-none" />
                  or YouTube or Netflix.
                </em>
              </h4>
              <h4 className="text-condensed text-800 text-center mb-0">
                <em>You can only get it all here, now!</em>
              </h4>
            </Col>
          </Row>
          <Row className="mb-4">
            <Col>
              <div className="tntg-speaker-wrap">
                <TntgSpeakerList />
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      <div className="impact-interviews text-center wrapper background-gradient-white-gray triangle-angles-top triangle-angles-top-white triangle-angles-offset-bottom">
        <Container>
          <Row>
            <Col>
              <h2>
                Unreleased <br className="d-none d-sm-block d-lg-none" />
                Extended Interviews
              </h2>
              <p>
                There’s only one way to get access to these additional interviews <br className="d-none d-lg-block" />
                with the featured experts in <em>The Need To GROW…</em>
              </p>
              <p>
                Plus more brilliant leaders who are making sure our <br className="d-none d-md-block d-xl-none" />
                food is safe, healthy, and accessible for all!
              </p>
            </Col>
          </Row>
          <Row className="d-flex justify-content-center align-items-stretch my-4">
            <InterviewList />
          </Row>
          <Row>
            <Col>
              <p>
                Podcast and audiobook fans will love having <br className="d-none d-sm-block d-lg-none" />
                each interview <br className="d-none d-lg-block" />
                in MP3 format to take with you <br className="d-none d-sm-block d-lg-none" />
                on the go, in the car, or in the garden.
              </p>
              <p className="mb-0">
                <strong>These complete interviews are offered nowhere else!</strong>
              </p>
            </Col>
          </Row>
        </Container>
      </div>

      <div className="background-gradient-white-yellow triangle-angles-top triangle-angles-top-white triangle-angles-offset-bottom wrapper">
        <Container>
          <Row className="mb-5">
            <Col>
              <h3 className="text-center text-condensed text-800 mb-2">And there’s more, too.</h3>
              <h4 className="text-center text-condensed text-800">
                You’ll also get over $500 worth of <br className="d-none d-md-block d-lg-none" />
                health-boosting, <br className="d-none d-lg-block d-xl-none" />
                food-growing, <br className="d-none d-xl-block" />
                world-changing bonuses from <br className="d-none d-lg-block d-xl-none" />
                our friends and partners.
              </h4>
            </Col>
          </Row>
          <Row>
            <Col>
              <div className="bonus-list-wrap">
                <BonusList />
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      <div className="impact-sale background-gradient-white-yellow triangle-angles-top triangle-angles-top-white triangle-angles-offset-bottom wrapper">
        <Container>
          <Row>
            <Col></Col>
          </Row>
          <Row>
            <Col>{salesCta}</Col>
          </Row>
        </Container>
        <Divider className="my-5" />
        <Container>
          <Row>
            <Col className="text-center mb-5">
              <h2 className="text-condensed text-800 mb-1">
                PLUS — Enjoy One More <br className="d-none d-sm-block" />
                Bonus Gift for FREE
              </h2>
              <h3 className="text-condensed text-800">($97 value)</h3>
              <p>
                We want to give you something extra because we know <br className="d-none d-lg-block" />
                how much you care about the planet and your health.
              </p>
              <p>
                <strong>
                  After you purchase your Impact Kit, you’ll be able to take your pick between any{' '}
                  <br className="d-none d-xl-block" />
                  one of these treasured four Health Collections from Food Revolution Network
                </strong>
              </p>
            </Col>
          </Row>
          <Row>
            <Col>
              <ThcBonusList />
            </Col>
          </Row>
          <Row>
            <Col>
              <h4 className="text-condensed text-800 text-center mb-0">
                You’ll get the Health Collection of your <br className="d-none d-md-block d-lg-none" />
                choice as a <br className="d-none d-xl-block" />
                completely FREE bonus (when you <br className="d-none d-md-block d-lg-none" />
                get the Impact Kit).
              </h4>
            </Col>
          </Row>
        </Container>
      </div>

      <div className="impact-sale background-gradient-white-gray triangle-angles-top triangle-angles-top-white triangle-angles-offset-bottom wrapper">
        <Container>
          <Row>
            <Col>
              <div className="text-center mb-5">
                <h2 className="text-condensed text-800 mb-3">
                  What will Earth look like <br className="d-none d-lg-block d-xl-none" />
                  two generations from now?
                </h2>
                <h4 className="text-400 mb-3">
                  Will it be a world without <br className="d-none d-sm-block d-md-none" />
                  butterflies, bees, trees, <br className="d-none d-lg-block" />
                  and healthy food, water, air, and people?
                </h4>
                <h4 className="text-400">
                  This terrifying nightmare is closer <br className="d-none d-sm-block d-lg-none" />
                  than we ever imagined...
                </h4>
                <h3 className="text-condensed text-800 mb-3">
                  But it’s NOT too late to pitch in <br className="d-none d-md-block d-xl-none" />
                  and change the fate of the planet.
                </h3>
                <h4 className="text-400 mb-3">Can we count on you to help?</h4>
                <h4 className="text-400">The time to act is NOW.</h4>
                <h2 className="text-condensed text-800 mt-4">Let’s GROW our Impact Together</h2>
                <Row className="trees-for-future d-flex align-items-center justify-content-center my-4">
                  <Col xs="11" lg="9" className="mb-4 mb-lg-0">
                    <h6 className="section-only-heading text-center text-lg-left text-400">
                      For every Impact Kit purchased, we make a donation to Trees for the Future, enabling them to plant
                      another organic fruit or nut tree in a low-income community.
                    </h6>
                  </Col>
                  <Col xs="11" lg="3" className="text-center">
                    <img className="logo-trees" src="https://cdn.foodrevolution.org/global/trees-logo-color.png" />
                  </Col>
                </Row>
                <p>
                  That means you’ll be supporting your health, <br className="d-none d-md-block d-lg-none" />
                  your family’s health, and <br className="d-none d-xl-block" />
                  your planet’s health while helping <br className="d-none d-md-block d-lg-none" />
                  to get this urgent message out to more people
                </p>
              </div>
              <Guarantee />
              <div className="mt-5 pt-4">
                <TestimonialBubble id="santina" />
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      <div className="impact-sale background-gradient-white-yellow triangle-angles-top triangle-angles-top-white wrapper">
        <Container>
          <Row>
            <Col>
              <div className="text-center mb-5">
                <h4 className="text-condensed text-800">
                  As we learned in the film, <br className="d-none d-sm-block d-lg-none" />
                  we’re running out of time.
                </h4>
                <p>
                  We’ve depleted our planet’s most critical resources, <br className="d-none d-md-block d-lg-none" />
                  threatening the health of ourselves, <br className="d-none d-xl-block" />
                  our children, and <br className="d-none d-md-block d-lg-none" />
                  countless species around the globe.
                </p>
                <p>
                  But if we act fast, it’s not too late to heal our soil and <br className="d-none d-md-block" />
                  regenerate our planet and the future of life on Earth.
                </p>
                <h3 className="text-condensed text-800 mb-2">
                  The stakes are high, <br className="d-none d-sm-block d-md-none" />
                  and the urgency is real.
                </h3>
                <h3 className="text-condensed text-800 mb-3">But so are the solutions!</h3>
                <h5>
                  A better world is possible. And together, <br className="d-none d-md-block d-xl-none" />
                  we can make it into a reality.
                </h5>
              </div>
              {salesCta}
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
}
